import type { MenuListProps as ChakraMenuListProps } from '@chakra-ui/react';
import { MenuList as ChakraMenuList, Portal } from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type MenuContentProps = OmitChakraProps<ChakraMenuListProps>;

/**
 * The wrapper component for any menu content.  Must be used with `Menu`
 */
export const MenuContent = withChakraAs<MenuContentProps, 'div'>((props) => {
  return (
    <Portal>
      <ChakraMenuList
        {...props}
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className={classnames('orbit-menu__content', props.className)}
      />
    </Portal>
  );
});
